module.exports = __webpack_public_path__ + "static/img/valet_user_default_icon.46609af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valet_user_default_icon.png
// module id = 454
// module chunks = 1